import React from 'react';
import { Presentation } from 'lucide-react';
import * as styles from './detailedCurriculum.module.scss';
import { SPRINTS, INTERVIEW_SPRINT } from './sprintsData';

const ShipItem = ({ item }) => (
  <li>
    <b>
      {item.id ? <a href={`#${item.id}`}>{item.name}</a> : item.name}
    </b>
    <em>{item.type}</em>
    <span>{item.desc}</span>
  </li>
);

const SprintArticle = ({ sprint, isInterview }) => (
  <article className={styles.sprint} id={sprint.id}>
    <div className={styles.sh}>
      <div className={styles.sn}>{isInterview ? '★' : sprint.num}</div>
      <div>
        <div className={styles.sw}>{sprint.week}</div>
        <h2>{sprint.title}</h2>
        <div className={styles.sm}>{sprint.meta}</div>
      </div>
    </div>
    <p className={styles.lead}>{sprint.lead}</p>
    <div className={styles.cols}>
      <div>
        <h3>What you&apos;ll learn</h3>
        <ul className={styles.pts}>
          {sprint.pts.map((pt) => (
            <li key={pt}>{pt}</li>
          ))}
        </ul>
        <div className={styles.chips}>
          {sprint.chips.map((chip) => (
            <span key={chip}>{chip}</span>
          ))}
        </div>
      </div>
      <div>
        {isInterview ? (
          <>
            <h3>You get</h3>
            <p className={styles.muted}>{sprint.youGet}</p>
          </>
        ) : (
          <>
            <h3>You ship</h3>
            <ul className={styles.ships}>
              {sprint.ships.map((item) => (
                <ShipItem item={item} key={item.name} />
              ))}
            </ul>
            <p className={styles.muted}>
              Every build is deployed, evaluated and assessed automatically against a rubric.
              Full detail on each one further down this page.
            </p>
            {sprint.demo && (
              <div className={styles.demo}>
                <Presentation size={14} className="mr-1 inline -mt-0.5" aria-hidden="true" />{' '}
                <b>Demo day</b> {sprint.demo}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  </article>
);

const CurriculumDeepDive = () => {
  return (
    <section className={styles.mint}>
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Curriculum <span className={styles.g}>deep dive.</span>
        </h2>
        <p className={styles.secSub}>
          Sprint by sprint: what is taught, the tools you&apos;ll use, and the builds you leave
          with. Ten live sessions per sprint with industry mentors, about 20 hours of take-home
          builds, every build assessed automatically against a rubric. Each build links to its
          full explanation further down the page.
        </p>
        {SPRINTS.map((sprint) => (
          <SprintArticle sprint={sprint} key={sprint.id} />
        ))}
        <SprintArticle sprint={INTERVIEW_SPRINT} isInterview />
        <p className={styles.muted}>
          Sequencing may be refined with our subject-matter experts before the cohort starts.
        </p>
      </div>
    </section>
  );
};

export default CurriculumDeepDive;
